import React from "react";
import { Button, Table, Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "@ant-design/compatible/assets/index.css";

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 8 },
    sm: { span: 8 },
  },
};

const ReminderTableElm = (props) => {
  const { schedules, columns, disabled, addSchedules } = props;

  return (
    <>
      <Table
        className="sm-custom-column-header"
        scroll={{ x: 50 }}
        bordered
        dataSource={schedules}
        columns={columns}
        rowClassName="editable-row"
        rowKey={(_record, index) => {
          return index;
        }}
        pagination={false}
      />
      <Form.Item {...formItemLayoutWithOutLabel}>
        <Button
          type="dashed"
          disabled={disabled}
          onClick={() => addSchedules(schedules)}
          style={{ width: "100%", left: "100%", top: 5 }}
        >
          <PlusOutlined />
          Add Reminder
        </Button>
      </Form.Item>
    </>
  );
};

export default ReminderTableElm;
